module.exports = __webpack_public_path__ + "img/food-35.2a19dd95.jpg";